/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'macmini': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" _fill="#C4FFF9" d="M20 61v23.571c0 2.4 1.536 3.929 3.929 3.929H126.07c2.393 0 3.929-1.528 3.929-3.929V61H20zm96.246 9.821a3.918 3.918 0 0 1-3.925-3.924 3.925 3.925 0 0 1 3.925-3.933 3.927 3.927 0 0 1 3.933 3.933 3.92 3.92 0 0 1-3.933 3.924z"/>'
  }
})
